import React, { memo, useState } from 'react';

import PropTypes from 'prop-types';
import { trim, size } from 'lodash';
import { FiSearch } from 'react-icons/fi';
import { useAsyncDebounce } from 'react-table';
import { useTranslation } from 'react-i18next';
import { TextField, InputAdornment } from '@mui/material';

import { TIMEOUT, MIN_LENGTH } from '../../../constants/FILTERS_OPTIONS';

const GlobalFilter = ({ globalFilter, setGlobalFilter }) => {
  const { t } = useTranslation();
  const [value, setValue] = useState(globalFilter);

  /**
   * Used to store filter
   * @param {string} value get filter value
   */
  const handleUpdateFilter = useAsyncDebounce((value) => {
    if (size(value) >= MIN_LENGTH || size(value) === 0) {
      setGlobalFilter(trim(value));
    }
  }, TIMEOUT);

  return (
    <TextField
      variant="outlined"
      label={t('search')}
      value={value || ''}
      onChange={(e) => {
        setValue(e.target.value);
        handleUpdateFilter(e.target.value);
      }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <FiSearch />
          </InputAdornment>
        ),
      }}
    />
  );
};

GlobalFilter.defaultProps = {
  globalFilter: '',
};

GlobalFilter.propTypes = {
  globalFilter: PropTypes.string,
  setGlobalFilter: PropTypes.func.isRequired,
};

export default memo(GlobalFilter);
